@if (isTrialPeriod) {
    <button
        class="inline-flex mr-2"
        mat-flat-button
        [color]="'accent'"
        [matTooltip]="hasTrialEndDate ? ('features.common.trial.tooltip' | transloco) : ''"
        (click)="navigateToUpgrade()">
        <mat-icon
            class="icon-size-5"
            [svgIcon]="'heroicons_outline:clock'"></mat-icon>
        <!-- A trial forced by the team has no end date: its status, without a countdown -->
        <span class="ml-2 hidden sm:inline">{{ hasTrialEndDate ? (trialText | transloco : {days: trialDaysRemaining}) : ('subscription-status.TRL' | transloco) }}</span>
    </button>
}
